<template>
  <div class="channel_list_page">
    <div class="page-title">{{title}}<i class="icontianjiaqudao iconfont" @click="addIsShow = true"></i> </div>
    <!-- 表格区域 -->
    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :pageSize="pageSize"
      :pageIndex="page"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @compFn="compFn"
    ></pageTable>
    <!-- 添加弹框 -->
    <add-channel-diag
      v-if="addIsShow"
      :isShow="addIsShow"
      @close="addIsShow = false"
      @hide="addIsShow = false"
      @success="addSuccess"
    ></add-channel-diag>
    <!-- 编辑弹框 -->
    <edit-channel-diag
      :isShow="editIsShow"
      :editData="editData"
      @close="editDiagClose"
      @success="diagSuccess"
      @hide="editIsShow = false"
    ></edit-channel-diag>
  </div>
</template>
<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import addChannelDiag from './diags/addChannelDiag.vue'
import editChannelDiag from './diags/editChannelDiag'
import { channelList } from '@/api/channel'
import Vue from 'vue'
import channelOpe1 from './channelOpe1'
import channelOpe2 from './channelOpe2'
import channelOpe3 from './channelOpe3'
Vue.component('channelOpe1', channelOpe1)
Vue.component('channelOpe2', channelOpe2)
Vue.component('channelOpe3', channelOpe3)
export default {
  name: 'channelList',
  components: {
    pageTable,
    addChannelDiag, editChannelDiag
  },
  mixins: [pageTableMixin],
  data() {
    return {
      title: '渠道列表',
      col: [
        { field: 'operation', title: '操作', width: 80, titleAlign: 'left', columnAlign: 'left', isResize: true, componentName: 'channelOpe1' },
        { field: 'agent_name', title: '渠道名称', width: 90, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'agent_logo_path_url', title: '平台LOGO', width: 95, titleAlign: 'left', columnAlign: 'left', isResize: true, componentName: 'channelOpe3' },
        { field: 'hy_cust_name', title: '户名', width: 55, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'hy_bank_name', title: '开户行', width: 55, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'hy_bank_no', title: '收款账号', width: 55, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'rule', title: '结算规则', width: 55, titleAlign: 'left', columnAlign: 'left', isResize: true, componentName: 'channelOpe2' }
      ],
      addIsShow: false, // 添加弹框是否展示
      editIsShow: false, // 编辑弹框
      editData: {} // 编辑弹框需要的初始数据
    }
  },
  methods: {
    getData() { // 搜索方法
      this.tableLoading = true
      channelList({
        rp: this.pageSize,
        'current_page': this.page
      }).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          this.tableData = res.result.data.map(obj => {
            obj.visible = false
            return obj
          })
          this.total = res.result.total
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    },
    initPage() {},
    compFn(params) {
      if (params.type === 'edit') { // 编辑操作
        this.editData = params.data
        this.editIsShow = true
      }
    },
    editDiagClose() {
      this.editIsShow = false
      this.editData = {}
    },
    diagSuccess() {
      this.getData()
    },
    addSuccess() { // 新增弹框成功s
      this.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.page-title {
  position: relative;
  .iconfont {
    position: absolute;
    right: 0px;
    bottom: -10px;
    cursor: pointer;
    color: $blue;
  }
}
</style>
